module.exports = __webpack_public_path__ + "static/media/oxygen7-logomark-white.9a8649c4.png";